define('views/modules/calendar/nutrition/nutrition-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // src
    'services/viewport',
    // events
    'services/layout',
    'services/events/nutrition-events',
    'services/events/layout-menu-events',
    // views
    'views/modules/calendar/calendar-item-panel',
    'views/modules/calendar/nutrition/nutrition-edit-content',
    'views/modules/feedback/feedback',
    'views/modules/calendar/favorite/favorite-content'

], function(
    // Libs
    _, Backbone, U,
    // src
    Viewport,
    // events
    LayoutState,
    NutritionEvents,
    LayoutMenuEvents,
    // views
    VCalendarItemPanel,
    VNutritionEditContent,
    VFeedbackContent,
    VFavoriteContent
) {

    var VNutritionPanel = VCalendarItemPanel.extend({
        header: {
            title: "calendar:Nutrition Log",
            subtitle: "calendar:Your daily nutrition log",
        },
        tabs: function() {
            var tabs = [
                { id: 'details', title: 'Edit', icon: 'sl-icon-note', active: true, callback: 'showDetails' },
                { id: 'feedback', title: 'calendar:Feedback', icon: 'sl-icon-bubbles', callback: 'showFeedback' },
                { id: 'favorite', title: 'Favorite', icon: 'sl-icon-star', callback: 'showFavorite' },
                { id: 'empty', empty: true },
            ];
            var tabsFiltered = _.reject(tabs, function(tab) {
                return tab.id === 'favorite' && this.options.role === 'client';
            }, this);

            if (tabsFiltered.length < 4) tabsFiltered.push({ id: 'empty2', empty: true });

            return tabsFiltered;
        },
        content: {
            details: VNutritionEditContent,
            feedback: VFeedbackContent,
            favorite: VFavoriteContent
        },
        defaultView: 'details',

        initListener: function() {
            this.stopListeningTo(NutritionEvents);
        },

        render: function() {
            this.initListener();
            VNutritionPanel.__super__.render.apply(this, arguments);
            return this;
        },

        /////////////////////////
        // T A B S (maximum 4) //
        /////////////////////////

        showFavorite: function() {
            this.showContent('favorite', {
                type: 'nutrilog',
                model: this.view.details.model
            });
            NutritionEvents.refreshPanel();
        },

        showDetails: function() {
            VNutritionPanel.__super__.showDetails.apply(this, arguments);
            NutritionEvents.refreshPanel();
        },

        showFeedback: function() {
            VNutritionPanel.__super__.showFeedback.apply(this, arguments);
            NutritionEvents.refreshPanel();
        },

        ////////////
        // events //
        ////////////
        onOpen: function(open) {
            var details = this.view.details;
            if (this.is(details) && !Viewport.isMobile() && this.model.isNew() && open) {
                details.toggleFoodPanel(true);
            }
            this.listenTo(LayoutMenuEvents, { 'item:click': this.onMenuClick });
        },

        onMenuClick: function() {
            this.close();
            this.stopListeningTo(LayoutMenuEvents, 'item:click');
        },

        // onExpandPanel: function() {
        //     if (LayoutState.isFull('info')) {
        //         LayoutState.toggleInfoFull();
        //     } else {
        //         this.view.details.toggleFoodPanel(true);
        //     }
        // },

    });

    return VNutritionPanel;
});

